import * as React from 'react';
import Chip from '@mui/material/Chip';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import CancelIcon from '@mui/icons-material/Cancel';

interface Props {
    status: 'QUEUED' | 'PROCESSING' | 'COMPLETED' | 'FAILED' | string;
}

const StatusChip: React.FC<Props> = ({ status }) => {
  switch (status) {
    case 'QUEUED':
      return (
        <Chip
          label="Queued"
          color="default" // Gray color
          size="small"
          icon={<HourglassEmptyIcon />}
        />
      );
    case 'PROCESSING':
      return (
        <Chip
          label="Processing"
          color="info" // Blue color
          size="small"
          icon={<SettingsSuggestIcon />}
        />
      );
    case 'COMPLETED':
      return (
        <Chip
          label="Completed"
          color="success" // Green color
          size="small"
          icon={<CheckCircleOutlineIcon />}
        />
      );
    case 'FAILED':
      return (
        <Chip
          label="Failed"
          color="error" // Red color
          size="small"
          icon={<CancelIcon />}
        />
      );
    default:
      return <Chip label={status} size="small" />;
  }
};

export default StatusChip;